export default function init_actions(IconsView, iconsViewCache) {

IconsView.prototype.action = function (action, options) {
        switch (action) {
        case 'refresh':
            this.refresh();
            break;
        case 'update':
            this.update();
            break;
        case 'remove':
            this.remove(options);
            break;
        default:
            break;
        }
    };


IconsView.prototype.menuOption = function (name, icon, action) {
        const myself = this;
        // iconPath
        return {
            name,
            icon,
            callback(icon) {
                myself.action(action, icon);
            },
        };
    }


IconsView.prototype.iconTrigger = function (icon, trigger) {
        if ($(icon).hasClass('.iv__item')) {
            icon = $(icon).closest('.iv__item');
        }
        const grid = $(icon).closest('.iconGrid');
        const myself = icon.data('plugin');
        let currentTrigger = this.options.event[trigger];


        // console.log(icon);

        if (icon.data('data').special == 'parent') currentTrigger = 'action';

        switch (currentTrigger) {
        // do the default action
        case 'action':
            if (icon.data('actions')) {
                var currentAction = icon.data('actions')[icon.data('default')];
                myself.action(currentAction, icon);
            }
            break;

            // multiple select
        case 'select':
            if (icon.data('data').selectable !== false) { myself.iconSelect(icon); }

            myself.changeSelection(icon);
            break;

            // select interval
        case 'selectInt':
            if (!this.options.features.lockSelection) {
                this.selection = [];
                var allIcons = grid.find('.iv__item');
                const selectedIcons = allIcons.filter('.iv__item--selected');
                if (selectedIcons.length > 0) {
                    // var direction = (icon.isAfter(this.selectionLast))?'after':'before';
                    allIcons.removeClass('iv__item--selected');
                    const icon1 = icon;
                    const icon2 = this.selectionLast;
                    let started = false;
                    $(allIcons).each(function () {
                        if (started) myself.iconSelect(this, true);
                        if ((icon1[0] == $(this)[0] || icon2[0] == $(this)[0])) {
                            myself.iconSelect(this, true);
                            started = !(started);
                        }
                    });
                    myself.changeSelection();
                    break;
                }
            }

            // single select
        case 'select1':
            if (!this.options.features.lockSelection) {
                this.selection = [];
                var allIcons = grid.find('.iv__item');
                if (allIcons.filter('.iv__item--selected').length <= 1) allIcons = allIcons.not(icon);
                allIcons.removeClass('iv__item--selected');
                if (icon.data('data').selectable !== false) { myself.iconSelect(icon, true); }
                myself.changeSelection(icon);
            }
            break;


            // context menu
        case 'menu':
            if (!icon.hasClass('iv__item--selected')) {
                grid.find('.iv__item--selected').removeClass('iv__item--selected');
                myself.selection = [];
                myself.iconSelect(icon, true);
                myself.changeSelection(icon);
            }
            myself.createMenu(icon.data('menu'), icon);
            // icon.contextMenu();
            break;


            // do the default action
        default:
            if (icon.data('actions')) {
                var currentAction = icon.data('actions')[currentTrigger];
                if (currentAction) {
                    myself.action(currentAction, icon);
                }
            }
            break;
        }
    };


IconsView.prototype.resize = function () {
        const myself = this;

        // ajust size
        var thumbsWidth = this.viewThumbsWidth;
        let thumbsHeight = this.viewThumbsHeight;
        if (thumbsWidth && myself.view == 'thumbnails') {
            var marginFix = 16;
            var canvaWidth = myself.element.find('.view').width() - 1;
            var colCount = canvaWidth / (thumbsWidth + marginFix);
            var colCountFix = Math.ceil(colCount);
            thumbsWidth = Math.floor((canvaWidth / colCountFix) - marginFix);
            thumbsHeight = thumbsHeight / this.viewThumbsWidth * thumbsWidth

            this.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').find('> div').css('max-width', thumbsWidth);
            this.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').find('.iv__item__image').css('width', thumbsWidth)
                .css('height', thumbsHeight);
        } else if (myself.view == 'mosaic') {
            var thumbsWidth = 400;
            var marginFix = 16;
            var canvaWidth = myself.element.find('.view').width();
            var colCount = canvaWidth / (thumbsWidth + marginFix);
            var colCountFix = Math.ceil(colCount);
            thumbsWidth = Math.floor((canvaWidth / colCountFix) - marginFix);

            this.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').css('width', thumbsWidth);
        }
        this.setIconSize();
    }


IconsView.prototype.action = function (action, element, actionName) {
        const myself = this;
        if (myself.lockActions) return false;
        if (action && element.data) {
            if (action.confirm) {
                Swal.fire({
                    title: action.confirm.title,
                    text: action.confirm.text,
                    type: (action.confirm.item) ? null : 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Non',
                }).then((result) => {
                    if (result.value) {
                        myself.actionExecute(action, element, actionName);
                    }
                })
            } else if (element) {
                myself.actionExecute(action, element, actionName);
            }

            return true;
        }
        return false;
    };


IconsView.prototype.actionExecute = function (action, element, actionName) {
        const myself = this;
        if (action) {
            // target data
            let grid;
            const dataId = {};
            let items = [];

            if (element) {
                if ($(element).hasClass('iconGrid')) {
                    grid = $(element);
                    element = grid.find('.iv__item--selected');
                    $.each(element, function (index, currentElement) {
                        if (actionName) {
                            const itemActions = $(this).data('actions');
                            if (!itemActions || !itemActions[actionName]) return;
                        }
                        const type = $(this).data('type');
                        if (!dataId[type]) dataId[type] = [];
                        dataId[type].push({
                            id: $(this).data('id'),
                        });
                        items.push({
                            id: $(this).data('id'),
                            data: $(this).data('data'),
                            el: $(this),
                        });
                    });
                } else {
                    grid = $(element).closest('.iconGrid');
                    dataId[element.data('type')] = [{
                        id: element.data('id'),
                    }];
                    items = [{
                        id: $(this).data('id'),
                        data: $(this).data('data'),
                        el: $(this),
                    }];
                }
                // var myself = grid.data('plugin');
                var data = element.data('data');

                // load from container data
                if (!data) {
                    data = myself.dataNodeParent;
                }
            }

            // data ID url
            let currentTab = this.containerView.find('.iv__tabs > .iv__tabs__nav__wrap > .iv__tabs__nav .ui-tabs-active').data('id');
            let { url } = action;
            if (element && !url && myself.options && myself.options.api && myself.options.api[element.data('type')]) {
                url = myself.options.api[element.data('type')];
            }
            url = String(url);
            url = url.replace('currentTab', currentTab);

            // auto target
            if (element) {
                url = url.replace('targetId', 'dataId');
                url = url.replace('targetSlug', 'dataSlug');
                url = url.replace('targetLabel', 'dataLabel');
                url = url.replace('targetType', 'dataType');
            }
            else {
                url = url.replace('targetId', 'parentId');
                url = url.replace('targetSlug', 'parentSlug');
                url = url.replace('targetLabel', 'parentLabel');
                url = url.replace('targetType', 'parentType');
            }

            // data replacement
            if (url && data && data.id) {
                url = url.replace('dataId', data.id);
                url = url.replace('dataSlug', data.slug);
                url = url.replace('dataLabel', data.label);
                url = url.replace('dataType', data.type);
                if (action.dataStr) url = url.replace('dataStr', data.data[action.dataStr]);
            }
            let urlData = (action.data ? '?' + jsonToUrl(action.data) : '');
            urlData = urlData.replace('currentTab', currentTab);
            if (data && data.id) {
                urlData = urlData.replace('dataId', data.id);
                urlData = urlData.replace('dataSlug', data.slug);
                urlData = urlData.replace('dataLabel', data.label);
                urlData = urlData.replace('dataType', data.type);
            }

            // parent ID url
            if (url.indexOf('parentId') != -1) {
                // ID of the true parent
                if (myself.dataNodeParent && myself.dataNodeParent.id) { // Replace parent ID macro
                    url = url.replace('parentId', myself.dataNodeParent.id);
                    url = url.replace('parentSlug', myself.dataNodeParent.slug);
                    url = url.replace('parentLabel', myself.dataNodeParent.label);
                    url = url.replace('parentType', myself.dataNodeParent.type);

                    url = url.replace('dataId', myself.dataNodeParent.id);
                    url = url.replace('dataSlug', myself.dataNodeParent.slug);
                    url = url.replace('dataLabel', myself.dataNodeParent.label);
                    url = url.replace('dataType', myself.dataNodeParent.type);
                }
                // Main root ID
                else if (myself.rootId) {
                    url = url.replace('parentId', myself.rootId);
                    url = url.replace('parentType', myself.rootType);

                    url = url.replace('dataId', myself.rootId);
                    url = url.replace('dataType', myself.rootType);
                }
                // No ID wipe all after
                else { // remove all after parentID if it don't exist
                    url = url.substring(0, url.indexOf('parentId'));
                    url = url.substring(0, url.indexOf('parentSlug'));
                    url = url.substring(0, url.indexOf('parentLabel'));
                    url = url.substring(0, url.indexOf('parentType'));

                    url = url.substring(0, url.indexOf('dataId'));
                    url = url.substring(0, url.indexOf('dataSlug'));
                    url = url.substring(0, url.indexOf('dataLabel'));
                    url = url.substring(0, url.indexOf('dataType'));
                }
            }

            // Api url
            if (url.indexOf('apiUrl') != -1) {
                url = url.replace('apiUrl', myself.options.api[data.type]);
            }

            // Tab id
            let tabId = this.element.find('.tabs > .tabs__nav__wrap > ul .ui-tabs-active');
            if (tabId) tabId = tabId.data('id');
            else tabId = null;
            url = url.replace('tabId', tabId);

            // prompt input
            if (url && url.includes('{{input1}}')) {
                url = url.replace(new RegExp('{{input1}}', 'g'), prompt());
            }

            // filter in URL
            $.each(myself.filters, (filterName, filter) => {
                url = url.replace('{{' + filterName + '}}', filter.value);
            });

            if (element) {
                var icon = element.closest('.iv__item');
            }

            switch (action.action) {
            case 'popup':
                if (action.replace) {
                    closeWindow(myself.element);
                }
                myself.isBusy = true;
                $.window({
                    id: 'itemWindow' + ((data) ? data.id : ''),
                    title: String((action.title) ? action.title : action.label).replace('%s', data.label),
                    url: url + urlData,
                    icon: (data && data.icon) ? data.icon : action.icon,
                    method: (left(action.url, 4) == 'http') ? 'iframe' : 'ajax',
                    maxWidth: -1, // the minimum width, if -1 means no checking
                    maxHeight: -1,		 // the minimum height, if -1 means no checking
                    showFooter: false,
                    maximizable: false,
                    closable: true,
                    showModal: true,
                    width: (action.width) ? action.width : 1000,
                    height: (action.height) ? action.height : 650,
                    checkBoundary: true,
                    withinBrowserWindow: false,
                    iconView: myself,
                    iconData: data,
                    formFill: (action.formFill) ? myself.filters : {},
                    onIframeEnd() {
                    },
                    onClose() {
                        if (!action.replace) {
                            this.iconView.quickLoad(this.iconData, this.returnData);
                            this.iconView.isBusy = false;
                        }
                    },
                });
                break;
            case 'newtab':
                var dataOut = [];
                for (var key in action.data) {
                    if (action.data.hasOwnProperty(key)) {
                        dataOut.push(key + '=' + encodeURIComponent(action.data[key]));
                    }
                }
                dataOut = dataOut.join('&');
                if (dataOut) dataOut = '?' + dataOut;

                window.open(url + dataOut, '_blank');
                break;
            case 'link':
                var dataOut = [];
                for (var key in action.data) {
                    if (action.data.hasOwnProperty(key)) {
                        dataOut.push(key + '=' + encodeURIComponent(action.data[key]));
                    }
                }
                dataOut = dataOut.join('&');
                if (dataOut) dataOut = '?' + dataOut;

                window.location.href = url + dataOut;
                break;
            case 'script':
                eval(action.script);
                break;
            case 'ajax':
                var options = {
                    url,
                    type: 'get',
                    data: action.data,
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                };
                if (action.success) options.success = action.success;
                if (action.complete) options.success = action.complete;
                var request = $.ajax(options);
                break;
            case 'ajaxForm':
                /* if (typeof dataId == 'number') {
                        dataId = [{
                            id: dataId
                        }]
                    } */
                $.each(dataId, (dataType, data) => {
                    if (action.data) {
                        for (let i = 0; i < data.length; i++) {
                            mergeToObject(action.data, data[i]);
                        }
                    }
                    if (!action.url) {
                        if (myself.options && myself.options.api && myself.options.api[dataType]) {
                            url = myself.options.api[dataType];
                        }
                    }
                    ajaxForm({
                        url,
                        method: action.method,
                        data,
                        plugin: myself,
                        success(data, form) {
                            this.plugin.quickLoad();
                        },
                    });
                });
                break;
            case 'update':
                myself.submitChange(data, action.data);
                break;
            case 'delete':
                myself.submitDelete(data);
                break;
            case 'browse':
                myself.setPath(data);
                myself.render(data.childs);
                break;
            case 'browseParent':
                myself.setPath(data.parent.parent);
                myself.render(data.parent.parent.childs);
                break;
            case 'mediaPreview':
                element.find('.iv__item__preview').click();
                break;
            case 'selectAll':
                grid.find('.iv__item').addClass('iv__item--selected');
                myself.changeSelection();
                break;
            case 'unselectAll':
                grid.find('.iv__item').removeClass('iv__item--selected');
                myself.changeSelection();
                break;
            case 'setView':
                myself.setView(action.view);
                break;
            case 'refresh':
                myself.render();
                break;
            case 'reload':
                myself.load();
                break;
            case 'sort':
                myself.sort(action.order, action.type);
                break;
            case 'add':
                myself.add(action.data);
                break;
            case 'remove':
                myself.remove(data);
                break;
            case 'select1':
                this.selection = [];
                var allIcons = grid.find('.iv__item');
                if (allIcons.filter('.iv__item--selected').length <= 1) allIcons = allIcons.not(icon);
                allIcons.removeClass('iv__item--selected');
                if (icon.data('data').selectable !== false) { myself.iconSelect(icon, true); }
                myself.changeSelection(icon);
                break;
            case 'multi':
                $.each(action.actions, function () {
                    element.data('plugin').actionExecute(this, element);
                });
                break;
            default:
                msg('info', 'The feature "' + action.action + '" is not implemented yet');
                break;
            }
            return true;
        }
        return false;
    };


IconsView.prototype.setView = function(view) {
        const myself = this;
        if (view == 'auto') {
            myself.viewLock = false;
            if (myself.template && myself.template.view && myself.template.view.default) myself.view = myself.template.view.default;
        } else if (view == 'next') {
            myself.viewLock = false;
            let currentViewIndex = myself.template.view.modes.indexOf(myself.view);
            currentViewIndex++;
            let currentView = myself.template.view.modes[currentViewIndex];
            if (!currentView) currentView = myself.template.view.modes[0];
            myself.view = currentView;
        } else {
            myself.viewLock = true;
            myself.view = view;
        }
        this.fixedSize[this.templateName] = null;
        this.fixedView[this.templateName] = myself.view;
        myself.setPath(this.path, true);
        myself.loadPath(null, true);
        myself.render();
    }


IconsView.prototype.iconSelect = function (icon, status, force) {
        if (!this.options.features.lockSelection || force) {
            icon = $(icon);
            if (!status && status !== false) status = 'toggle';
            if (icon.data('data').selectable !== false) {
                if (status == 'toggle') icon.toggleClass('iv__item--selected');
                if (status == true) {
                    icon.addClass('iv__item--selected');
                }
                if (status == false) {
                    icon.removeClass('iv__item--selected');
                }

                if (icon.hasClass('iv__item--selected')) {
                    this.addSelectionFromIcon(icon);
                } else {
                    this.removeSelectionFromIcon(icon);
                }
            }
        }
    };


}
